import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useEffectOnce } from '@carvana/merch-react-hooks';
import { useContext } from 'react';

function useTrackHeroPerformace() {
  const { trackEvent } = useContext(AnalyticsContext);

  useEffectOnce(() => {
    trackEvent('Home Hero Load Time', {
      loadTime: performance.now()
    });
  }, [trackEvent]);
}

export default useTrackHeroPerformace;
